/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TicketShopDesignPreviewViewViewModel } from 'app/modules/design/ticket-shop-design/ticket-shop-design-detail/models/ticket-shop-design-preview-view-view.model';
import { TicketShopDesignDetailService } from 'app/modules/design/ticket-shop-design/ticket-shop-design-detail/services/ticket-shop-design-detail.service';
import { environment } from 'environments/environment';
import { TicketShopDesignPreviewViewModel } from '../models/ticket-shop-design-preview-view.model';

@Component({
	selector: 'ticket-shop-design-preview-view',
	templateUrl: './ticket-shop-design-preview-view.component.html',
	styleUrls: ['./ticket-shop-design-preview-view.component.scss'],
	standalone: false,
})
export class TicketShopDesignPreviewViewComponent implements OnInit, OnChanges {
	@Input() ticketShopDesignId: number;
	@Input() eventId?: number;
	viewModel: TicketShopDesignPreviewViewViewModel;
	public iframeUrl: SafeResourceUrl;
	public showPreview = false;

	constructor(
		private route: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private service: TicketShopDesignDetailService,
	) {}

	ngOnInit() {
		this.loadViewModel();
	}

	ngOnChanges() {}

	loadViewModel() {
		if (!this.ticketShopDesignId) {
			return;
		}
		this.service.getTicketShopDesignPreviewView(this.ticketShopDesignId, this.eventId).then((response: TicketShopDesignPreviewViewModel) => {
			this.viewModel = new TicketShopDesignPreviewViewViewModel(response);
			this.showPreview = this.viewModel.dataModel.showPreview;
			this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ticketShopUrl + '/' + this.viewModel.dataModel.iframeUrl);
		});
	}

	get noPreviewMessage(): string {
		if (!this.ticketShopDesignId) {
			return 'Cannot preview a new ticket shop design.';
		}
		return 'Preview will be displayed here once the design is associated with an organiser.';
	}

	public reload() {
		this.loadViewModel();
	}

	doIconButtonAction(action) {
		switch (action) {
			default: {
				console.log('Unsupported action: ' + action);
				break;
			}
		}
	}
}
